import { UseQueryResult, useQuery } from 'react-query'
import request from '../request'
import { Pagination } from '../../lib/types/Pagination'
import { Dealership } from '../../lib/types/Dealership'

type ResultType = Dealership

export const useGetPaginatedDriveCentricDealerships = ({
  pageIndex,
  pageSize,
}: {
  pageIndex?: number
  pageSize?: number
}): UseQueryResult<{ data: ResultType[]; pagination: Pagination }, Error> => {
  return useQuery<{ data: ResultType[]; pagination: Pagination }, Error>(
    ['admin', 'partners', 'drivecentric', { pageIndex, pageSize }],
    ({ signal }) =>
      request({
        url: `/admin/partners/drivecentric`,
        method: 'GET',
        params: {
          pageIndex,
          pageSize,
        },
        signal,
      }),
  )
}
